<div
  #banner
  class="banner-container"
  [attr.role]="dismissible ? 'dialog' : null"
  [attr.aria-label]="dismissible ? 'Preferências de cookies' : null"
  [attr.tabindex]="dismissible ? -1 : null"
>
  @if (dismissible) {
    <button
      type="button"
      class="banner-close"
      (click)="close()"
      aria-label="Fechar preferências de cookies"
    >
      <app-icon>close</app-icon>
    </button>
  }
  <div class="text-content">
    <p class="color-neutral-00 font-size-14 line-height-20">
      <strong>Utilizamos cookies</strong>
      para oferecer uma melhor experiência. Você pode aceitar todas as
      categorias ou ajustar suas preferências. Para mais informações leia nossa
      <a
        class="text-decoration-underline color-neutral-00"
        href="https://closecare.com.br/politica-de-privacidade"
        target="_blank"
        rel="noopener noreferrer"
      >
        política de privacidade
      </a>
      e
      <a
        class="text-decoration-underline color-neutral-00"
        href="https://closecare.com.br/termos-de-uso"
        target="_blank"
        rel="noopener noreferrer"
      >
        termos de uso
      </a>
      .
    </p>

    @if (showPreferences) {
      <fieldset class="preferences">
        <legend class="sr-only">Categorias de cookies</legend>

        <label class="category">
          <input type="checkbox" checked disabled />
          <span class="category-text">
            <strong>Essenciais</strong>
            <small>
              Necessários para autenticação, sessão e segurança. Sempre ativos.
            </small>
          </span>
        </label>

        <label class="category">
          <input
            type="checkbox"
            [(ngModel)]="analyticsChecked"
            name="cookies-analytics"
          />
          <span class="category-text">
            <strong>Analytics</strong>
            <small>
              Eventos agregados para entender o uso do produto. Sem gravação de
              tela.
            </small>
          </span>
        </label>

        <label class="category">
          <input
            type="checkbox"
            [(ngModel)]="sessionRecordingChecked"
            name="cookies-session-recording"
          />
          <span class="category-text">
            <strong>Gravação de sessão</strong>
            <small>
              Gravação anônima de cliques, scroll e navegação para identificar
              pontos de fricção.
            </small>
          </span>
        </label>
      </fieldset>
    }
  </div>

  <!--
    LGPD/CNIL: "recusar deve ser tão fácil quanto aceitar" — the rule
    forbids HIDING or making the reject illegible, not different visual
    weight. "Aceitar todos" is the primary CTA (solid blue). "Apenas
    essenciais" uses white-outline: white text/border on the dark banner
    (~9:1 contrast — fully legible), same top level, single click — so it
    stays compliant while drawing less attention than the solid CTA.
    A ghost/grey treatment was rejected because grey-on-dark (#626262 on
    #3a3a3a ≈ 1.9:1) would be illegible and itself a dark pattern.
  -->
  <div class="button-container">
    @if (!showPreferences) {
      <app-button
        (click)="togglePreferences()"
        [disabled]="submitted"
        variant="white-outline"
      >
        Preferências
      </app-button>
      <app-button
        (click)="acceptEssentialOnly()"
        [disabled]="submitted"
        variant="white-outline"
      >
        Apenas essenciais
      </app-button>
      <app-button
        (click)="acceptAll()"
        [disabled]="submitted"
        variant="primary"
      >
        Aceitar todos
      </app-button>
    } @else {
      <app-button
        (click)="acceptEssentialOnly()"
        [disabled]="submitted"
        variant="white-outline"
      >
        Apenas essenciais
      </app-button>
      <app-button
        (click)="savePreferences()"
        [disabled]="submitted"
        variant="primary"
      >
        Salvar preferências
      </app-button>
    }
  </div>
</div>
